module.exports = __webpack_public_path__ + "static/media/add_content.eaf2067c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/swipe/add_content.mp4
// module id = 266
// module chunks = 0